import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Insights", path: "/insights" },
  { label: "Trading Academy", path: "/trading-academy" },
  { label: "Advisory", path: "/advisory" },
  { label: "Partnerships", path: "/partnerships" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-white/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="/assets/brand/logo.png"
            alt="Harambee Global Ventures Logo"
            className="h-12 w-auto object-contain"
          />
          <span
            className={`lg:hidden text-sm font-semibold tracking-[0.28em] ${
              scrolled || !isHome ? "text-[#2B2D2F]" : "text-white"
            }`}
          >
            HGV
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-7">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? "text-[#C9A961]"
                  : scrolled || !isHome
                  ? "text-[#2B2D2F] hover:text-[#C9A961]"
                  : "text-white/90 hover:text-[#C9A961]"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/contact"
            className="px-5 py-2.5 rounded-md text-sm font-medium bg-[#C9A961] text-[#2B2D2F] hover:bg-[#b8943f] transition-colors whitespace-nowrap cursor-pointer"
          >
            Book Consultation
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i
            className={`text-2xl ${
              scrolled || !isHome ? "text-[#2B2D2F]" : "text-white"
            } ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}
          />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium py-2 cursor-pointer ${
                location.pathname === link.path
                  ? "text-[#C9A961]"
                  : "text-[#2B2D2F] hover:text-[#C9A961]"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="mt-2 px-5 py-3 rounded-md text-sm font-medium bg-[#C9A961] text-[#2B2D2F] text-center whitespace-nowrap cursor-pointer"
          >
            Book Consultation
          </Link>
        </div>
      )}
    </header>
  );
}
